// axios
import axios from 'axios'

const domain = "https://crm.evblock.com/"

export default axios.create({
  domain
  // You can add your headers here
})
